import React, { useEffect } from 'react'
import { TextField, Grid, Date, Box, Button } from "@mui/material"
import { useForm, Controller } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { FreeRideFourSchema } from '../../Utils/Validations'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
const RideFormFour = ({ handleBack, handleComplete, freeRideData, setFreeRideData }) => {
  const [selectedDate, setSelectedDate] = React.useState(dayjs());
  const { handleSubmit, control, formState: { errors }, setValue } = useForm({
    resolver: yupResolver(FreeRideFourSchema)
  })
  useEffect(() => {
    setValue("transport_date", freeRideData.transport_date || dayjs())
    setValue("street_name", freeRideData.street_name || "")
  }, [])
  const onSubmit = (data) => {
    console.log(data)
    setFreeRideData((prev) => ({ ...prev, transport_date: selectedDate, street_name: data.street_name }))
    handleComplete()
  }
  return (
    <div>

      <Grid container style={{ justifyContent: "center", marginTop: 20 }} >
        <Grid sm={6} xs={12} sx={{ textAlign: "left", paddingRight: { sm: 1, xs: 0 } }} >
          <Controller
            control={control}
            name="transport_date"
            rules={{ required: true }}
            render={({ field:{onChange,value} }) => (
              <>
                <label>Transport Date (MM-DD-YYYY)</label>

                <DatePicker
                  sx={{width:"100%"}}
                  className='date-picker'
                  value={value}
                  onChange={(newValue) => {
                    setSelectedDate(newValue);
                    onChange(newValue)
                  }}
                  renderInput={(params) => <TextField {...params} fullWidth />}
                />


              </>
            )}
          />


        </Grid>
        <Grid sm={6} xs={12} sx={{ textAlign: "left", paddingLeft: { sm: 1, xs: 0 }, marginTop: { sm: 0, xs: 2 } }}>
          <Controller
            control={control}
            name="street_name"
            rules={{ required: true }}
            render={({ field }) => (
              <>
                <label>Street Name</label>
                <TextField fullWidth placeholder='Street Name' error={errors.street_name} {...field} helperText={errors?.street_name?.message} />

              </>
            )}
          />
        </Grid>
      </Grid>
      <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2,pb:2 }}>
        <Button
          color="inherit"
          // disabled={activeStep === 0}
          onClick={handleBack}
          sx={{ minWidth: "10%", border: "none", color: "#FFF", bgcolor: "#97c11e", '&:hover': { bgcolor: "#021b38", border: "none" } }}
          variant="contained"
        >
          Back
        </Button>
        <Box sx={{ flex: '1 1 auto' }} />


        <Button color="inherit" variant="contained" sx={{ minWidth: "10%", border: "none", color: "#FFF", bgcolor: "#97c11e", '&:hover': { bgcolor: "#021b38", border: "none" } }} onClick={handleSubmit(onSubmit)}>


          Next
        </Button>

      </Box>
    </div>
  )
}

export default RideFormFour